import React from 'react';
import SquadDashboard from '../domains/squads/components/SquadDashboard';

const SquadDashboardPage: React.FC = () => {
  return <SquadDashboard />;
};

export default SquadDashboardPage; 